// Function to check availability based on both start and end date requirements
function checkDateRangeAvailability(startDate, endDate, monthlyTimeSlots, hoursToCheck = 24) {
  // Convert input dates to Date objects if they're strings
  const start = startDate instanceof Date ? startDate : new Date(startDate);
  const end = endDate instanceof Date ? endDate : new Date(endDate);

  // Check if the day before the start date is available
  const previousDay = new Date(start);
  previousDay.setHours(previousDay.getHours() - hoursToCheck);
  const isStartValid = isDayInAnyTimeSlot(previousDay, monthlyTimeSlots);

  // Check if the day after the end date is available
  const nextDay = new Date(end);
  nextDay.setHours(nextDay.getHours() + hoursToCheck);
  const isEndValid = isDayInAnyTimeSlot(nextDay, monthlyTimeSlots);

  // Overall availability - both conditions must be true
  const isAvailable = isStartValid && isEndValid;

  return {
    available: isAvailable,
    startCheck: {
      valid: isStartValid,
      date: start.toISOString(),
      requiredPreviousDay: previousDay.toISOString(),
    },
    endCheck: {
      valid: isEndValid,
      date: end.toISOString(),
      requiredNextDay: nextDay.toISOString(),
    },
    hoursChecked: hoursToCheck,
  };
}

// Helper function to check if a specific day is in any time slot
function isDayInAnyTimeSlot(date, monthlyTimeSlots) {
  const checkDate = date instanceof Date ? date : new Date(date);

  // Iterate through each month in the data
  for (const month in monthlyTimeSlots) {
    const monthData = monthlyTimeSlots[month];

    // Skip if there's an error or no time slots
    if (monthData.fetchTimeSlotsError || !monthData.timeSlots || monthData.timeSlots.length === 0) {
      continue;
    }

    // Check each time slot in the month
    for (const slot of monthData.timeSlots) {
      const slotStart = new Date(slot.attributes.start);
      const slotEnd = new Date(slot.attributes.end);

      // Check if the date falls within this time slot
      if (checkDate >= slotStart && checkDate <= slotEnd) {
        return true;
      }
    }
  }

  // If the date is not in any time slot
  return false;
}

// Example monthly time slots data
const monthlyTimeSlots = {
  '2025-04': {
    fetchTimeSlotsError: null,
    fetchTimeSlotsInProgress: false,
    timeSlots: [
      {
        id: { _sdkType: 'UUID', uuid: '6808c440-ead4-4cd6-a0fc-bad6fdaf1ffd' },
        type: 'timeSlot',
        attributes: {
          type: 'time-slot/time',
          seats: 1,
          start: '2025-04-23T22:00:00.000Z',
          end: '2025-04-24T07:00:00.000Z',
        },
      },
      {
        id: { _sdkType: 'UUID', uuid: '6808c440-ed54-4379-b8ca-31ef0bcb1781' },
        type: 'timeSlot',
        attributes: {
          type: 'time-slot/time',
          seats: 1,
          start: '2025-04-24T19:00:00.000Z',
          end: '2025-04-25T07:00:00.000Z',
        },
      },
      {
        id: { _sdkType: 'UUID', uuid: '6808c440-1337-4eed-b6d0-028ee8a1e989' },
        type: 'timeSlot',
        attributes: {
          type: 'time-slot/time',
          seats: 1,
          start: '2025-04-25T19:00:00.000Z',
          end: '2025-04-26T07:00:00.000Z',
        },
      },
      {
        id: { _sdkType: 'UUID', uuid: '6808c440-66ed-442a-ad87-2eecd167bd4a' },
        type: 'timeSlot',
        attributes: {
          type: 'time-slot/time',
          seats: 1,
          start: '2025-04-26T19:00:00.000Z',
          end: '2025-04-27T07:00:00.000Z',
        },
      },
      {
        id: { _sdkType: 'UUID', uuid: '6808c440-509c-4c59-9a46-8146e4a06bd7' },
        type: 'timeSlot',
        attributes: {
          type: 'time-slot/time',
          seats: 1,
          start: '2025-04-27T19:00:00.000Z',
          end: '2025-04-29T07:00:00.000Z',
        },
      },
    ],
  },
  '2025-05': {
    fetchTimeSlotsError: null,
    fetchTimeSlotsInProgress: false,
    timeSlots: [
      {
        id: { _sdkType: 'UUID', uuid: '6808c440-fff4-4988-a736-2950cd2bf599' },
        type: 'timeSlot',
        attributes: {
          type: 'time-slot/time',
          seats: 1,
          start: '2025-04-30T22:00:00.000Z',
          end: '2025-05-03T07:00:00.000Z',
        },
      },
    ],
  },
};

// Test cases
console.log('Test Case 1: Both start and end checks pass');
// April 25-26 (April 24 and April 27 are both available)
console.log(
  checkDateRangeAvailability(
    '2025-04-25T12:00:00.000Z',
    '2025-04-26T12:00:00.000Z',
    monthlyTimeSlots
  )
);

console.log('\nTest Case 2: Start check passes, end check fails');
// April 25-28 (April 24 is available, but April 29 is not)
console.log(
  checkDateRangeAvailability(
    '2025-04-25T12:00:00.000Z',
    '2025-04-28T12:00:00.000Z',
    monthlyTimeSlots
  )
);

console.log('\nTest Case 3: Start check fails, end check passes');
// April 22-25 (April 21 is not available, but April 26 is)
console.log(
  checkDateRangeAvailability(
    '2025-04-22T12:00:00.000Z',
    '2025-04-25T12:00:00.000Z',
    monthlyTimeSlots
  )
);

console.log('\nTest Case 4: Both start and end checks fail');
// April 22-28 (April 21 and April 29 are both not available)
console.log(
  checkDateRangeAvailability(
    '2025-04-22T12:00:00.000Z',
    '2025-04-28T12:00:00.000Z',
    monthlyTimeSlots
  )
);

console.log('\nTest Case 5: With 12 hours check instead of 24');
// Same as Test Case 1 but with 12 hours
console.log(
  checkDateRangeAvailability(
    '2025-04-25T12:00:00.000Z',
    '2025-04-26T12:00:00.000Z',
    monthlyTimeSlots,
    12
  )
);

// Test with dates that span into May
console.log('\nTest Case 6: Date range spanning into May');
console.log(
  checkDateRangeAvailability(
    '2025-04-29T12:00:00.000Z',
    '2025-05-01T12:00:00.000Z',
    monthlyTimeSlots
  )
);

export default checkDateRangeAvailability;
